// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gst-details-card-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.gst-details-card-wrapper .gst-text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gst-details-card-wrapper .gst-text-wrapper .primary-text {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.gst-details-card-wrapper .gst-text-wrapper .secondary-text {
  font-size: 15px;
  font-weight: 500;
  color: #7a7a7a;
}
.gst-details-card-wrapper .gst-input-details-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gst-details-card-wrapper .gst-input-details-wrapper input {
  background: #f8f8f8;
  outline: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 400;
  padding: 12px 14px;
  width: 100%;
  color: #000;
}
.gst-details-card-wrapper .gst-input-details-wrapper input::placeholder {
  color: #aeaeae;
}
.gst-details-card-wrapper .gst-input-details-wrapper input:focus-visible {
  outline: 1px solid #93288E;
}
.gst-details-card-wrapper .gst-input-details-wrapper .relative-wrapper {
  position: relative;
  width: 100%;
}
.gst-details-card-wrapper .gst-input-details-wrapper .relative-wrapper .abs-wrapper {
  position: absolute;
  top: 28%;
  right: 10px;
  cursor: pointer;
}
.gst-details-card-wrapper .gst-input-details-wrapper .relative-wrapper .loader {
  border-radius: 50%;
  border: 2px solid #93288E;
  border-left-color: transparent;
  width: 24px;
  height: 24px;
  animation: inputspinner 1s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/GstDetailsCard/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AACR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AACZ;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAZ;AAII;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAFR;AAIQ;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAFZ;AAGY;EACA,cAAA;AADZ;AAGY;EACI,0BAAA;AADhB;AAKQ;EACI,kBAAA;EACA,WAAA;AAHZ;AAKY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAHhB;AAMY;EACI,kBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AAJhB","sourcesContent":[".gst-details-card-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n\n    .gst-text-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        .primary-text {\n            font-size: 18px;\n            font-weight: 700;\n            color: #000;\n        }\n\n        .secondary-text {\n            font-size: 15px;\n            font-weight: 500;\n            color: #7a7a7a;\n        }\n    }\n\n    .gst-input-details-wrapper {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n\n        input {\n            background: #f8f8f8;\n            outline: none;\n            border-radius: 6px;\n            font-size: 16px;\n            font-weight: 400;\n            padding: 12px 14px;\n            width: 100%;\n            color: #000;\n            &::placeholder{\n            color: #aeaeae;\n            }\n            &:focus-visible{\n                outline: 1px solid #93288E;\n            }\n        }\n\n        .relative-wrapper{\n            position: relative;\n            width: 100%;\n\n            .abs-wrapper{\n                position: absolute;\n                top: 28%;\n                right: 10px;\n                cursor: pointer;\n            }\n\n            .loader {\n                border-radius: 50%;\n                border: 2px solid #93288E;\n                border-left-color: transparent;\n                width: 24px;\n                height: 24px;\n                animation: inputspinner 1s linear infinite;\n              }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
